module.exports = __webpack_public_path__ + "static/media/metop_intro.1f99d67f.png";